import { COMPONENT_VALUE_TYPES as types, PERCENTAGES } from 'shared/constants';

const propsSchema = [
  {
    key: 'url',
    label: 'Image URL (Recommended dimension: at least 1600px wide)',
    type: types.TEXT
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'left_offset',
    label: 'Left Offset Percentage',
    type: types.ENUM,
    options: PERCENTAGES
  },
  {
    key: 'caption',
    label: 'Caption',
    type: types.TEXT
  },
  {
    key: 'bg_color',
    label: 'Background Color',
    type: types.COLOR_PICKER
  },
];

const defaultProps = {
  url: 'https://genesis-cdn.ff.com/ffzero1/03_the_ux/ff-zero-1-steering-wheel-screen-01.jpg',
  title: 'Smartphone Connectivity',
  left_offset: 60,
  caption: `The driver's smartphone can be connected directly into the car, allowing for real-time data visualization and interaction. Used separately, the smartphone app enables remote setup, customized vehicle configurations, and adjustable power outputs.`,
  bg_color: '#eaeaea'
};

export default {
  title: 'Descriptive Image',
  id: 'DescriptiveImage',
  propsSchema,
  defaultProps
};
